import type { FileListFilters } from "@/react/components/entityViews/files/api/files.query-keys";
import type { FileListOrdering, FileSource } from "@/react/components/entityViews/files/types/swivuFile";
import { datePresetToUploadedBounds, type DatePreset } from "./datePresetBounds";

export type FileTypeTab = "media" | "documents" | "all";
export type FileSourceTab = "all" | FileSource;

export type { DatePreset, FileListOrdering };

export interface FileBrowserFilterState {
  fileTypeTab: FileTypeTab;
  source: FileSourceTab;
  datePreset: DatePreset;
  /** Debounced search string passed into the list query */
  search: string;
  ordering: FileListOrdering;
}

export const DEFAULT_FILE_BROWSER_FILTERS: FileBrowserFilterState = {
  fileTypeTab: "media",
  source: "all",
  datePreset: "any",
  search: "",
  ordering: "-uploaded_at",
};

/** Map UI browser filters → EntityFileProvider / GET /file/list params. */
export function toFileListFilters(state: FileBrowserFilterState): FileListFilters {
  const filters: FileListFilters = {
    ordering: state.ordering,
  };

  if (state.fileTypeTab === "media") filters.fileType = "image";
  if (state.fileTypeTab === "documents") filters.fileType = "document";

  if (state.source === "swivu" || state.source === "companycam") {
    filters.source = state.source;
  }

  const trimmed = state.search.trim();
  if (trimmed) filters.search = trimmed;

  const bounds = datePresetToUploadedBounds(state.datePreset);
  if (bounds.uploadedAfter) filters.uploadedAfter = bounds.uploadedAfter;
  if (bounds.uploadedBefore) filters.uploadedBefore = bounds.uploadedBefore;

  return filters;
}

/**
 * Default Manage-modal list filters for Media / Documents tiles.
 * Keep identical to SwivuTaskFilesEditor’s initial `toFileListFilters` so the
 * dash tile and Manage share one React Query cache on open.
 */
export const MEDIA_TILE_FILE_LIST_FILTERS = toFileListFilters({
  ...DEFAULT_FILE_BROWSER_FILTERS,
  fileTypeTab: "media",
});

export const DOCUMENTS_TILE_FILE_LIST_FILTERS = toFileListFilters({
  ...DEFAULT_FILE_BROWSER_FILTERS,
  fileTypeTab: "documents",
});
